import '@/lib/sentry';
import '@/i18n/i18n';
import '@nrg/design-system/styles.css';
import './index.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from '@/App';
import { configureAmplify } from '@/auth/amplify-config';

configureAmplify();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
